import React from 'react';
import './TagList.scss';
import Chip from '@Shared.Angular/flowingly.components/Chip/Chip';

type TagListProps = {
  groupedSelectedTags: Record<string, { tags: string[]; color: string }>;
  showBorder?: boolean;
};

const TagList = ({ groupedSelectedTags, showBorder = true }: TagListProps) => {
  const hasTags = Object.keys(groupedSelectedTags).length > 0;

  return (
    <div className={`tag-list-container ${showBorder ? 'with-border' : ''}`}>
      {hasTags ? (
        Object.entries(groupedSelectedTags).map(([category, groupInfo]) => (
          <div key={category} className="tag-group">
            <p className="category-label">{category}</p>
            <div className="chip-wrapper">
              {groupInfo.tags.map((tagName) => (
                <Chip key={tagName} name={tagName} color={groupInfo.color} />
              ))}
            </div>
          </div>
        ))
      ) : (
        <p className="no-tags-text">No Tags Added</p>
      )}
    </div>
  );
};

export default TagList;
